import Loader from "../../../assets/loader/loader.gif";

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#fff",
    padding: "24px",
    borderRadius: "5px",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 2px 0px",
    gap: "16px",
  },
  detailsContainer: {
    display: "flex",
    gap: "20px",
    width: "100%",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  detailItem: {
    display: "flex",
    flexDirection: "column",
    gap: "0px",
  },
  label: {
    fontSize: "12px",
    color: "#888",
  },
  value: {
    fontSize: "14px",
    fontWeight: "500",
  },
  valueStatus: {
    fontSize: "14px",
    fontWeight: "700",
  },
};

type ProductCardProps = {
  orderListByIdData?: { [key: string]: string | any }; // ✅ Dynamic Key-Value Pair
  isOrderListByIdDataLoading?: boolean;
};

const OrderBillCard: React.FC<ProductCardProps> = ({
  orderListByIdData,
  isOrderListByIdDataLoading,
}) => {
  const statusColorMap: Record<string, string> = {
    Created: "#3498db",
    Accepted: "#2ecc71",
    Executed: "#f39c12",
    Completed: "#1abc9c",
    Cancelled: "#e74c3c",
    Rejected: "#c0392b",
    Modified: "#9b59b6",
  };

  const backgroundRemarkColor: Record<string, string> = {
    Created: "#d6eaf8", // Light Blue
    Accepted: "#d5f5e3", // Light Green
    Executed: "#fdebd0", // Light Orange
    Completed: "#d1f2eb", // Light Teal
    Cancelled: "#f5b7b1", // Soft Red
    Rejected: "#ebdef0", // Light Purple
    Modified: "#e8daef", // Light Lavender
  };
  const RemarkColorMap: Record<string, string> = {
    "No Remark Available": "#c0392b", // red
  };

  const billedTo = orderListByIdData?.data?.outletToData;
  const billedFrom = orderListByIdData?.data?.outletFromData;
  const billDate = orderListByIdData?.data?.orderData?.OrderDate;
  const billRemark =
    orderListByIdData?.data?.orderData?.OrderRemark == "" ||
    orderListByIdData?.data?.orderData?.OrderRemark == null ||
    orderListByIdData?.data?.orderData?.OrderRemark == undefined
      ? "No Remark Available"
      : orderListByIdData?.data?.orderData?.OrderRemark;
  const billStatus = orderListByIdData?.data?.orderData?.OrderStatus;
  const billStatusColor = statusColorMap[billStatus] || "#e0e0e0";
  const billRemarkColor = RemarkColorMap[billRemark] || "#e0e0e0";
  const billRemarkBackgroundColor =
    backgroundRemarkColor[billStatus] || "#e0e0e0";
  const noBillRemarkColor = RemarkColorMap
    ? RemarkColorMap[billRemark]
    : "#e0e0e0e0";

  return (
    <div style={styles.container}>
      {isOrderListByIdDataLoading ? (
        <div
          style={{
            padding: "20px",
            textAlign: "center",
            width: "100%",
          }}
        >
          <img src={Loader} alt="Loading..." style={{ height: 40 }} />
        </div>
        
      ) : (
        <div style={{ width: "100%" }}>
          <div style={styles.detailsContainer}>
            <div style={styles.detailItem}>
              <p style={styles.label}>Billed To:</p>
              <p style={styles.value}>{billedTo?.OutlettypeName || "-"}</p>
              <p style={styles.value}>{billedTo?.OutletName || "-"}</p>
              <p style={styles.value}>{billedTo?.OutletContactNo || "-"}</p>
            </div>
            <div style={styles.detailItem}>
              <p style={styles.label}>Billed By:</p>
              <p style={styles.value}>{billedFrom?.OutlettypeName || "-"}</p>
              <p style={styles.value}>{billedFrom?.OutletName || "-"}</p>
              <p style={styles.value}>{billedFrom?.OutletContactNo || "-"}</p>
            </div>
            <div style={styles.detailItem}>
              <p style={styles.value}>Date: {billDate || "-"}</p>
              <div style={{ display: "flex", flexDirection: "row" }}>
                <p style={styles.value}>Order Status </p>
                <p style={{ color: billStatusColor, ...styles?.valueStatus }}>
                  {` : ${billStatus || "-"}`}
                </p>
              </div>
            </div>
          </div>

          {billRemark && (
            <div
              style={{
                display: "flex",
                backgroundColor: billRemark
                  ? billRemarkBackgroundColor
                  : "#e0e0e0",
                padding: "5px",
                border: `1px solid ${billRemarkBackgroundColor}`,
                borderRadius: "4px",
                marginTop: "12px",
              }}
            >
              <p
                style={{
                  ...styles.value,
                  color: billStatusColor,
                }}
              >
                Remark
              </p>
              <p
                style={{
                  ...styles?.value,
                  color:
                    billRemark == "No Remark Available"
                      ? noBillRemarkColor
                      : billStatusColor,
                }}
              >{`  :  ${billRemark || "-"}`}</p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default OrderBillCard;
